import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AdminLogin() {
  const { login, isAuthenticated, loading, error } = useAuth();
  const navigate = useNavigate();
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [showPw,   setShowPw]   = useState(false); // ← ADD

  useEffect(() => { 
    if (!loading && isAuthenticated) navigate('/admin'); 
  }, [isAuthenticated, loading, navigate]);

  async function handleSubmit(e) {
    e.preventDefault();
    const ok = await login(email, password);
    if (ok) navigate('/admin');
  }

  const inp = { width:'100%', border:'1px solid #e5e7eb', padding:'11px 14px', fontSize:13, outline:'none', fontFamily:'var(--font-body)', color:'var(--dark)', background:'#fff', transition:'border-color 0.2s', boxSizing:'border-box' };

  return (
    <div style={{ minHeight:'100vh', background:'var(--cream)', display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
      <div style={{ width:'100%', maxWidth:380, background:'#fff', padding:'40px 36px', boxShadow:'var(--shadow-lg)' }}>
        <div style={{ textAlign:'center', marginBottom:36 }}>
          <div style={{ fontFamily:'var(--font-display)', fontSize:22, fontWeight:300, letterSpacing:'0.2em', textTransform:'uppercase', color:'var(--dark)', marginBottom:4 }}>Aurora Luxury</div>
          <div style={{ fontSize:11, letterSpacing:'0.2em', textTransform:'uppercase', color:'var(--gold)', fontWeight:500 }}>Admin Portal</div>
        </div>

        <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:16 }}>
          <div>
            <label style={{ fontSize:11, color:'var(--grey-dark)', display:'block', marginBottom:6, letterSpacing:'0.05em' }}>Email Address</label>
            <input type="email" value={email} onChange={e=>setEmail(e.target.value)} required style={inp}
              onFocus={e=>e.target.style.borderColor='var(--dark)'} onBlur={e=>e.target.style.borderColor='#e5e7eb'} />
          </div>

          {/* ── Password with show/hide ── */}
          <div>
            <label style={{ fontSize:11, color:'var(--grey-dark)', display:'block', marginBottom:6, letterSpacing:'0.05em' }}>Password</label>
            <div style={{ position:'relative', display:'flex', alignItems:'center' }}>
              <input
                type={showPw ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                style={{ ...inp, paddingRight: 42 }}
                onFocus={e => e.target.style.borderColor = 'var(--dark)'}
                onBlur={e => e.target.style.borderColor = '#e5e7eb'}
              />
              <button
                type="button"
                onClick={() => setShowPw(v => !v)}
                aria-label={showPw ? 'Hide password' : 'Show password'}
                style={{ position:'absolute', right:12, background:'none', border:'none', cursor:'pointer', padding:4, display:'flex', alignItems:'center', color:'#9ca3af' }}
              >
                {showPw
                  ? <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                  : <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                }
              </button>
            </div>
          </div>

          {error && <p style={{ fontSize:12, color:'var(--red)', textAlign:'center' }}>{error}</p>}

          <button type="submit" disabled={loading}
            style={{ width:'100%', padding:'14px 0', marginTop:8, background:'var(--dark)', color:'#fff', fontSize:11, letterSpacing:'0.2em', textTransform:'uppercase', fontWeight:600, border:'none', cursor:loading?'not-allowed':'pointer', opacity:loading?0.7:1, transition:'background 0.2s' }}
            onMouseEnter={e=>{ if(!loading) e.target.style.background='var(--gold)'; }}
            onMouseLeave={e=>e.target.style.background='var(--dark)'}>
            {loading ? 'Signing In…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}

// import { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';

// export default function AdminLogin() {
//   const { login, isAuthenticated, loading, error } = useAuth();
//   const navigate = useNavigate();
//   const [email,    setEmail]    = useState('');
//   const [password, setPassword] = useState('');
//   const [showPw,   setShowPw]   = useState(false);

//   useEffect(() => {
//     if (!loading && isAuthenticated) navigate('/admin');
//   }, [isAuthenticated, loading, navigate]);

//   async function handleSubmit(e) {
//     e.preventDefault();
//     const ok = await login(email, password);
//     if (ok) navigate('/admin');
//   }

//   return (
//     <div className="min-h-screen bg-[var(--cream)] flex items-center justify-center p-6">
//       <div className="w-full max-w-[380px] bg-white px-9 py-10 shadow-[var(--shadow-lg)]">

//         {/* Header */}
//         <div className="text-center mb-9">
//           <div className="font-display text-[22px] font-light tracking-[0.2em] uppercase text-[var(--dark)] mb-1">
//             Aurora Luxury
//           </div>
//           <div className="text-[11px] tracking-[0.2em] uppercase text-[var(--gold)] font-medium font-body">
//             Admin Portal
//           </div>
//         </div>

//         <form onSubmit={handleSubmit} className="flex flex-col gap-4">

//           {/* Email */}
//           <div>
//             <label className="block text-[11px] text-[var(--grey-dark)] mb-1.5 tracking-[0.05em] font-body">
//               Email Address
//             </label>
//             <input
//               type="email"
//               value={email}
//               onChange={e => setEmail(e.target.value)}
//               required
//               className="aurora-input focus:border-[var(--dark)]"
//             />
//           </div>

//           {/* Password */}
//           <div>
//             <label className="block text-[11px] text-[var(--grey-dark)] mb-1.5 tracking-[0.05em] font-body">
//               Password
//             </label>
//             <div className="relative flex items-center">
//               <input
//                 type={showPw ? 'text' : 'password'}
//                 value={password}
//                 onChange={e => setPassword(e.target.value)}
//                 required
//                 className="aurora-input focus:border-[var(--dark)] pr-10"
//               />
//               <button
//                 type="button"
//                 onClick={() => setShowPw(v => !v)}
//                 aria-label={showPw ? 'Hide password' : 'Show password'}
//                 className="absolute right-3 flex items-center text-[var(--grey-mid)] bg-transparent border-none cursor-pointer p-1"
//               >
//                 {showPw ? (
//                   <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24">
//                     <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
//                     <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
//                     <line x1="1" y1="1" x2="23" y2="23"/>
//                   </svg>
//                 ) : (
//                   <svg width={18} height={18} fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24">
//                     <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
//                     <circle cx="12" cy="12" r="3"/>
//                   </svg>
//                 )}
//               </button>
//             </div>
//           </div>

//           {/* Error */}
//           {error && (
//             <p className="text-[12px] text-[var(--red)] text-center font-body">
//               {error}
//             </p>
//           )}

//           {/* Submit */}
//           <button
//             type="submit"
//             disabled={loading}
//             className="w-full py-3.5 mt-2 bg-[var(--dark)] text-white text-[11px] tracking-[0.2em] uppercase font-semibold border-none cursor-pointer transition-colors duration-200 hover:bg-[var(--gold)] disabled:opacity-70 disabled:cursor-not-allowed font-body"
//           >
//             {loading ? 'Signing In…' : 'Sign In'}
//           </button>

//         </form>
//       </div>
//     </div>
//   );
// }